<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="specials Excerpt" id="section_excerpt--num_1--seq_1"> <p class="fp" id="rw-fp_114615-00001"><a id="pb-rw_1"><b>‘No helpless female would dare</b> <b>to board my ship alone, and</b> <b>with nothing on her person for</b> <b>protection. </b></a></p><a id="pb-rw_1"> <div class="paras leading-line" id="rw-paras-leading-line_114615-00001"> <p class="fp">   </p></div> <p class="fp" id="rw-p_114615-00002">‘You deserve a commendation for sheer guts, Rowena. I salute your courage and your boldness. You are undeniably brave—as well as beautiful. But your father is in debt to me up to his ears. Would you compound that debt by adding to it?’</p> <div class="paras leading-line" id="rw-paras-leading-line_114615-00002"> <p class="fp">     </p></div> <p class="fp" id="rw-p_114615-00003">‘There is something I could give in payment.’</p> <div class="paras leading-line" id="rw-paras-leading-line_114615-00003"> <p class="fp">   </p></div> <p class="fp" id="rw-p_114615-00004">‘Could you, indeed? You mean that you and I could have—a very delightful arrangement?’</p> <div class="paras leading-line" id="rw-paras-leading-line_114615-00004"> <p class="fp">   </p></div> <p class="fp" id="rw-p_114615-00005">His voice was like silk, and his eyes had become a warm and very appreciative blue, and Rowena knew immediately what price he was asking her to pay. She felt fury rise up inside her—not just with him, but with herself and at the excitement which stirred at the very idea…</p></a></div><a id="pb-rw_1">
</a></div><a id="pb-rw_1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781408913727_excerpt.vue?fcfb05de